import { useEffect, useRef, useState } from 'react';

function Section({ id, title, subtitle, children, className = '' }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;

    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id={id}
      ref={ref}
      className={`landing-section reveal ${isVisible ? 'reveal-visible' : ''} ${className}`.trim()}
      aria-label={title || id}
    >
      {(title || subtitle) && (
        <div className="section-heading">
          {title && <h2>{title}</h2>}
        </div>
      )}
      {children}
    </section>
  );
}

export default Section;
